"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkUpdateCreditorPaymentInfo = exports.updateCreditorPaymentInfo = exports.createCreditorPaymentInfo = exports.PixKeyType = void 0;
const string_utils_1 = require("../common/string.utils");
const payment_1 = require("../payment");
const utils_1 = require("./utils");
const zod_1 = require("zod");
__exportStar(require("./utils"), exports);
var PixKeyType;
(function (PixKeyType) {
    PixKeyType["PHONE"] = "phone";
    PixKeyType["EMAIL"] = "email";
    PixKeyType["RANDOM"] = "random";
    PixKeyType["CPF_OR_CNPJ"] = "cpf_or_cnpj";
    PixKeyType["INVALID"] = "invalid";
})(PixKeyType = exports.PixKeyType || (exports.PixKeyType = {}));
const createCreditorPaymentInfoObj = zod_1.z.object({
    active: zod_1.z.boolean(),
    external_creditor_id: zod_1.z.string().max(255).transform(string_utils_1.normalizeCreditor),
    name: zod_1.z.string().max(255).trim().optional(),
    document_number: zod_1.z
        .string()
        .max(50)
        .refine(document => (0, utils_1.isCPF)(document) || (0, utils_1.isCNPJ)(document), {
        message: 'Documento inválido (CPF ou CNPJ)',
    }),
    pix_key: zod_1.z
        .string()
        .max(60)
        .refine(key => isValidPixKey(key), {
        message: 'Chave PIX inválida (CPF ou CNPJ / e-mail / número de telefone celular / chave aleatória)',
    })
        .nullable()
        .optional(),
    bank_code: zod_1.z.string().max(20).nullable().optional(),
    branch: zod_1.z.string().max(20).nullable().optional(),
    account_type: zod_1.z.nativeEnum(payment_1.AccountType).nullable().optional(),
    account: zod_1.z.string().max(50).nullable().optional(),
});
const updateCreditorPaymentInfoObj = createCreditorPaymentInfoObj
    .partial()
    .omit({ external_creditor_id: true });
const bulkUpdateCreditorPaymentInfoObj = updateCreditorPaymentInfoObj.extend({
    external_creditor_id: zod_1.z.string().max(255).transform(string_utils_1.normalizeCreditor),
});
const checkVarExistsOrNull = (variable) => {
    return variable === null || variable !== undefined;
};
const applyPixOrBankInfoValidation = (obj) => obj.refine(data => {
    if (checkVarExistsOrNull(data.pix_key) ||
        checkVarExistsOrNull(data.bank_code) ||
        checkVarExistsOrNull(data.branch) ||
        checkVarExistsOrNull(data.account_type) ||
        checkVarExistsOrNull(data.account)) {
        if (data.pix_key && data.pix_key !== null) {
            return true;
        }
        else {
            return data.bank_code && data.branch && data.account_type && data.account;
        }
    }
    else {
        return true;
    }
}, {
    message: 'Chave PIX ou informações bancárias devem ser informadas',
    path: ['pix_key', 'bank_code', 'branch', 'account_type', 'account'],
});
const isValidPixKey = (key) => {
    try {
        (0, utils_1.parsePixKeyType)(key);
        return true;
    }
    catch (error) {
        return false;
    }
};
exports.createCreditorPaymentInfo = applyPixOrBankInfoValidation(createCreditorPaymentInfoObj);
exports.updateCreditorPaymentInfo = applyPixOrBankInfoValidation(updateCreditorPaymentInfoObj);
exports.bulkUpdateCreditorPaymentInfo = applyPixOrBankInfoValidation(bulkUpdateCreditorPaymentInfoObj).array();
